module.exports = __webpack_public_path__ + "media/images/front/about/aboutdba_point01-2-eed686b4f1c36ee476a7bf4bfbe68622.jpg";